/**
 * Aevex Collection Editorial
 * Quick price filters, animated checkmarks, product count
 */
(function () {
  'use strict';

  var section = document.querySelector('.collection-editorial');
  if (!section) return;

  var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ─── Animated Checkmarks (scroll-triggered) ─── */
  var checks = section.querySelectorAll('.collection-editorial__check');

  if ('IntersectionObserver' in window && !reducedMotion) {
    var checkObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-revealed');
        checkObserver.unobserve(entry.target);
      });
    }, { threshold: 0.3, rootMargin: '0px 0px -5% 0px' });

    checks.forEach(function (check, index) {
      check.style.transitionDelay = (index * 120) + 'ms';
      checkObserver.observe(check);
    });
  } else {
    checks.forEach(function (check) { check.classList.add('is-revealed'); });
  }

  /* ─── Price Filter Logic ─── */
  var grid = document.querySelector('.collection-product-grid');
  if (!grid) return;

  var allCards = Array.prototype.slice.call(grid.querySelectorAll('.product-card'));
  var filterButtons = section.querySelectorAll('.collection-editorial__filter');
  var countBadge = section.querySelector('[data-editorial-count]');
  var filterStatus = section.querySelector('.collection-editorial__filter-status');
  var activeFilter = 'all';

  /* Parse price from a product card */
  function getCardPrice(card) {
    var priceEl = card.querySelector('.price__current');
    if (!priceEl) return 0;
    var text = priceEl.textContent.replace(/[^0-9.]/g, '');
    return parseFloat(text) || 0;
  }

  /* Tag cards with price data on load */
  allCards.forEach(function (card) {
    card.setAttribute('data-editorial-price', String(getCardPrice(card)));
  });

  /* Update product count badge */
  function updateCount(visible) {
    if (countBadge) {
      countBadge.textContent = visible + ' system' + (visible !== 1 ? 's' : '') + ' available';
    }
  }

  /* Filter cards by price range */
  function filterCards(range) {
    activeFilter = range;
    var visible = 0;

    allCards.forEach(function (card) {
      var price = parseFloat(card.getAttribute('data-editorial-price')) || 0;
      var show = false;

      switch (range) {
        case 'all':
          show = true;
          break;
        case 'under-1000':
          show = price > 0 && price < 1000;
          break;
        case '1000-2000':
          show = price >= 1000 && price <= 2000;
          break;
        case '2000-plus':
          show = price > 2000;
          break;
      }

      if (show) {
        visible++;
        card.style.display = '';
        card.style.opacity = '1';
        card.style.transform = '';
      } else {
        card.style.opacity = '0';
        card.style.transform = 'scale(0.96) translateY(8px)';
        setTimeout(function () {
          if (activeFilter !== range) return;
          card.style.display = 'none';
        }, 280);
      }
    });

    updateCount(visible);

    if (filterStatus) {
      if (range === 'all') {
        filterStatus.textContent = '';
      } else {
        var labels = {
          'under-1000': 'Under $1,000',
          '1000-2000': '$1,000 – $2,000',
          '2000-plus': '$2,000+'
        };
        filterStatus.textContent = 'Showing ' + visible + ' system' + (visible !== 1 ? 's' : '') + ' in ' + labels[range];
      }
    }
  }

  /* Update filter counts from actual product data */
  function updateFilterCounts() {
    var counts = { 'all': 0, 'under-1000': 0, '1000-2000': 0, '2000-plus': 0 };

    allCards.forEach(function (card) {
      var price = parseFloat(card.getAttribute('data-editorial-price')) || 0;
      counts['all']++;
      if (price > 0 && price < 1000) counts['under-1000']++;
      if (price >= 1000 && price <= 2000) counts['1000-2000']++;
      if (price > 2000) counts['2000-plus']++;
    });

    filterButtons.forEach(function (btn) {
      var range = btn.getAttribute('data-filter');
      var countEl = btn.querySelector('.collection-editorial__filter-count');
      if (countEl && counts[range] !== undefined) {
        countEl.textContent = counts[range];
      }
    });

    updateCount(counts['all']);
  }

  /* Attach click handlers */
  filterButtons.forEach(function (btn) {
    btn.addEventListener('click', function () {
      var range = btn.getAttribute('data-filter');
      if (range === activeFilter) return;

      filterButtons.forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      filterCards(range);
    });
  });

  /* Initialize counts */
  updateFilterCounts();

  /* ─── Smooth card transitions on filter ─── */
  allCards.forEach(function (card) {
    card.style.transition = 'opacity 0.28s cubic-bezier(0.2, 0.7, 0.2, 1), transform 0.28s cubic-bezier(0.2, 0.7, 0.2, 1)';
  });

})();
